import { FaCookieBite } from 'react-icons/fa';
import { MdOutlineCookie } from 'react-icons/md';
import React, { useEffect, useState } from 'react';
// import cookieImage from '../../assets/cookie.png';

const CookieConsentBanner = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const updatedPreferences = {
      necessary: true,
      analytics: true,
      marketing: true,
    };
    localStorage.setItem('cookieConsent', JSON.stringify(updatedPreferences));
    setPreferences(updatedPreferences);
    setShowConsent(false);
  };

  const handleRejectAll = () => {
    const updatedPreferences = {
      necessary: true,
      analytics: false,
      marketing: false,
    };
    localStorage.setItem('cookieConsent', JSON.stringify(updatedPreferences));
    setPreferences(updatedPreferences);
    setShowConsent(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    setShowConsent(false);
    setShowCustomize(false);
  };

  const handlePreferenceChange = (name) => {
    setPreferences((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  if (!showConsent) return null;

  return (
    <div className='cookie-banner'>
      {!showCustomize ? (
        <div>
          <div className='mb-3 flex items-center'>
            <h2 className='m-0 text-lg font-semibold'>We value your privacy</h2>
            <FaCookieBite className='ml-2 text-xl text-[#bb8855]' />
          </div>

          <p className='cookie-banner-text'>
            We use cookies to enhance your Browse experience, serve personalized ads or content, and
            analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
          </p>
          <div className='cookie-banner-actions'>
            <button
              className='button-outline-main button-outline'
              onClick={() => setShowCustomize(true)}
            >
              Customize
            </button>
            <button
              className='button-outline-main button-outline'
              onClick={handleRejectAll}
            >
              Reject All
            </button>
            <button
              className='button-outline-main button-cookies'
              onClick={handleAcceptAll}
            >
              Accept All
            </button>
          </div>
        </div>
      ) : (
        <div>
          <h2 className='customize-title'>Cookie Preferences</h2>
          <div className='customize-options'>
            <div className='customize-option'>
              <div className='option-header'>
                <span className='option-title'>Necessary Cookies</span>
                <span className='badge badge-active'>Always Active</span>
              </div>
              <p className='option-description'>
                Essential for website functionality, such as navigation and secure areas. Always
                enabled.
              </p>
            </div>
            <div className='customize-option'>
              <div className='option-header'>
                <span className='option-title'>Analytics Cookies</span>
                <div
                  className={`toggle-switch ${preferences.analytics ? 'on' : ''}`}
                  onClick={() => handlePreferenceChange('analytics')}
                >
                  <div className='slider'></div>
                </div>
              </div>
              <p className='option-description'>
                Help us analyze site usage to improve performance and user experience with anonymous
                data.
              </p>
            </div>
            <div className='customize-option'>
              <div className='option-header'>
                <span className='option-title'>Marketing Cookies</span>
                <div
                  className={`toggle-switch ${preferences.marketing ? 'on' : ''}`}
                  onClick={() => handlePreferenceChange('marketing')}
                >
                  <div className='slider'></div>
                </div>
              </div>
              <p className='option-description'>
                Enable personalized ads and content based on your Browse behavior and interests.
              </p>
            </div>
          </div>
          <div className='cookie-banner-actions'>
            <button
              className='button-outline-main button-cookies'
              onClick={handleSavePreferences}
            >
              Save Preferences
            </button>
            <button
              className='button-outline-main button-outline'
              onClick={() => setShowCustomize(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsentBanner;
